/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-01-05T10:42:26.803
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveFinancialElectronicAccountFreeze,
	getFinancialElectronicAccountFreezeCreateInit,
	getFinancialElectronicAccountFreezeEditInit,
	getFinancialElectronicAccountFreezeView,
	deleteFinancialElectronicAccountFreeze
} from '@api/financial/FinancialElectronicAccountFreeze';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getFinancialElectronicAccountFreezeCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinancialElectronicAccountFreezeCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialElectronicAccountFreezeEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialElectronicAccountFreezeEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinancialElectronicAccountFreeze({}, FinancialElectronicAccountFreeze) {
			return new Promise((resolve, reject) => {
				saveFinancialElectronicAccountFreeze(FinancialElectronicAccountFreeze)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialElectronicAccountFreezeView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialElectronicAccountFreezeView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialElectronicAccountFreeze({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialElectronicAccountFreeze({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
